import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Policy from './pages/Policy';
import './App.css';
const MEASUREMENT_ID = "G-V7JK3VRJBV";

ReactGA.initialize(MEASUREMENT_ID);


function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <>
      <Router>
        <Routes>
          <Route path="/policy/:code" element={<Policy />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
